import React from 'react';

export interface SelectProps extends React.SelectHTMLAttributes<HTMLSelectElement> {}

/** Design-system native select, styled to match Input. */
export const Select = React.forwardRef<HTMLSelectElement, SelectProps>(
  ({ style, className = '', children, ...rest }, ref) => (
    <select
      ref={ref}
      className={`focus:border-[var(--lime)] focus:ring-1 focus:ring-[var(--lime)] transition-colors ${className}`}
      style={{
        background: 'var(--surface-2)',
        border: '1px solid var(--border)',
        borderRadius: 'var(--radius-md)',
        color: 'var(--text-primary)',
        padding: '8px 11px',
        fontSize: 13.5,
        fontFamily: 'var(--font-sans)',
        outline: 'none',
        cursor: 'pointer',
        ...style,
      }}
      {...rest}
    >
      {children}
    </select>
  ),
);
Select.displayName = 'Select';

export default Select;
